import React from 'react';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { useLogFrontendApiError } from '@edreamsodigeo/frontend-core';
import { SelectedCabinBagsContext } from 'context';
import { useShoppingBundleInfo } from 'hooks';
import { GET_SHOPPING_BUNDLE } from './SelectedCabinBagsProvider.query';
import { useEffect, useState } from 'react';
import { getSelectedCabinBagsData } from 'utils';

export const SelectedCabinBagsProvider = ({ children }) => {
  const shoppingInfo = useShoppingBundleInfo();
  const response = useQuery(GET_SHOPPING_BUNDLE, {
    skipCache: true,
    variables: {
      request: {
        shoppingInfo,
      },
    },
  });
  const [data, setData] = useState(getSelectedCabinBagsData(response.data));

  useLogFrontendApiError(response);

  useEffect(() => {
    setData(getSelectedCabinBagsData(response.data));
  }, [response.data]);

  return (
    <SelectedCabinBagsContext.Provider value={{ response, data, setData }}>
      {children}
    </SelectedCabinBagsContext.Provider>
  );
};
